<template>
    <div>
        <label class="biz-policy-checkbox">
            <span :class="{'active': isChecked}">
                <img v-show="isChecked" :src="checkedImg" alt="">
            </span>
            <input type="checkbox" :value="isChecked" v-model="checked" @change="onChange" />
            <div class="policy-content">
                {{checkboxMsg}}
            </div>
        </label>
    </div>
</template>
<script>
export default {
    name: 'policyCheckbox',
    data () {
        return {
            isChecked: this.isPropChecked,
            checkVal: '',
            checkedImg: require('@/assets/img/component/widge/checkbox/tick_white.svg'),
        }
    },
    props: {
        checkboxMsg: String,
        val: '',
        value: '',
        policyId: '',
        isPropChecked: {
            default: true,
            type: Boolean
        },
        setDefault: Boolean
    },
    mounted () {
        // this.setTickColor();
    },
    watch: {
        setDefault: function () {
            if(this.setDefault){
                this.isChecked = this.setDefault
            }
        }
    },
    computed: {
        checked: {
            get () {
                return this.value
            },
            set (value) {
                let data = {
                    value: !this.isChecked,
                    id: this.policyId,
                    name: this.checkboxMsg
                }
                this.checkVal = data
            }
        }
    },
    methods: {
        onChange: function(e) {
            this.isChecked = !this.isChecked;
            this.$emit('input', this.checkVal)
        },
        // setTickColor: function () {
        //     if( this.tickColor == 'black' ){
        //         this.checkedImg = require('@/assets/img/component/widge/checkbox/tick_black.svg');
        //     }else if( this.tickColor == 'white' ){
        //         this.checkedImg = require('@/assets/img/component/widge/checkbox/tick_white.svg');
        //     }
        // },
    }
}
</script>
<style   lang="scss">
    .biz-policy-checkbox{
        position: relative;
        display: flex;
        padding: 20px;
        border-radius: 4px;
        border: solid 1px #f3f3f3;
        background-color: #ffffff;
        margin-bottom: 12px;
        box-sizing: border-box;
        cursor: pointer;
        span{
            display: flex;
            align-items: center;
            justify-content: center;
            width: 20px;
            height: 20px;
            font-weight: 300;
            margin-right: 20px;
            border-radius: 3px;
            border: 1px solid #d5dad8;
            background: #fff;
        }
        span.active{
            border: 1px solid #ff9275;
            background: #ff9275;
        }
        input{
            display: none;
        }
        .policy-content{
            width: 660px;
            height: 62px;
            overflow-x: hidden;

        }
        .policy-content::-webkit-scrollbar {
            display: none;
        }
    }
    
    // @media screen and (max-width: 1280px) {
    //     .policy-checkbox{
    //         width: 1100px;
    //     }
    // }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/widges/tools/PolicyCheckbox.vue